import DecreaseIcon from "assets/images/icons/decrease.svg";
import IncreaseIcon from "assets/images/icons/increase.svg";
import { useEffect, useState, useRef } from "react";

const WordpressOrder = ({ currentProduct, productGroup, setHostingProduct }) => {
  const [cloudPop, setCloudPop] = useState(0);
  const isInitializingRef = useRef(true);
  const lastPidRef = useRef(null);

  const cloudPopHandle = (e) => {
    const btnName = e.target.alt;
    const limiter = productGroup.length;

    if (btnName.includes("increase") && cloudPop < limiter - 1) {
      const newIndex = cloudPop + 1;
      const targetProduct = productGroup[newIndex];
      if (targetProduct) {
        setCloudPop(newIndex);
        setHostingProduct({
          type: "SET_CURRENT_PID",
          payload: targetProduct.pid
        });
      }
    }
    if (btnName.includes("decrease") && cloudPop !== 0) {
      const newIndex = cloudPop - 1;
      const targetProduct = productGroup[newIndex];
      if (targetProduct) {
        setCloudPop(newIndex);
        setHostingProduct({
          type: "SET_CURRENT_PID",
          payload: targetProduct.pid
        });
      }
    }
    return;
  };

  useEffect(() => {
    if (productGroup.length !== 0 && currentProduct.current?.pid) {
      const currentPid = currentProduct.current.pid;

      // Cegah update jika PID sama dengan yang terakhir (mencegah loop)
      if (lastPidRef.current === currentPid && !isInitializingRef.current) {
        return;
      }

      const productIndex = productGroup.findIndex(
        (prod) => prod.pid === currentPid
      );

      if (productIndex !== -1) {
        const newCloudPop = productIndex <= 0 ? 0 : productIndex;

        // Hanya update jika berbeda untuk mencegah loop
        if (cloudPop !== newCloudPop || isInitializingRef.current) {
          setCloudPop(newCloudPop);
          lastPidRef.current = currentPid;
          isInitializingRef.current = false;
        }
      }
    }
  }, [productGroup, currentProduct, cloudPop]);

  return (
    <div className="cloudpop-wrapper custom-product" id="sec-wordpress-hosting">
      <label htmlFor="cloudPop" className="form-label fw-bold mb-0">
        CloudPOP
      </label>
      <div className="d-flex align-items-center flex-wrap">
        <label htmlFor="increaseItem">Jumlah:</label>
        <div className="d-flex align-items-center ms-5 gap-2">
          <button className="btn btn-link p-0" onClick={cloudPopHandle}>
            <img src={DecreaseIcon} alt="decrease.svg" />
          </button>
          <div id="popTotal" className="mx-3">
            {cloudPop}
          </div>
          <button className="btn btn-link p-0" onClick={cloudPopHandle}>
            <img src={IncreaseIcon} alt="increase.svg" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WordpressOrder;
